import React from 'react'

export const LanguageSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="14"
      viewBox="0 0 24 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.322 12.5L3.906 2.7H5.922L9.506 12.5H7.602L6.818 10.232H2.996L2.198 12.5H0.322ZM3.486 8.832H6.328L4.9 4.758L3.486 8.832ZM19.4904 3.736L21.2824 4.254C19.5184 9.294 16.2564 12.234 11.2444 13.802C11.0484 13.382 10.5164 12.57 10.1804 12.164C15.0244 10.89 18.0344 8.3 19.4904 3.736ZM14.0864 3.848C15.5004 7.992 18.5244 10.974 23.5084 12.094C23.1024 12.486 22.5564 13.284 22.2904 13.774C17.0404 12.402 14.1564 9.196 12.4064 4.352L14.0864 3.848ZM10.4324 2.826H23.2564V4.478H10.4324V2.826ZM15.9344 0.613999H17.6704V3.834H15.9344V0.613999Z"
        fill="black"
      />
    </svg>
  )
}
